module.exports = __webpack_public_path__ + "img/share.56c298b4.svg";